const moduleName = 'iframeScrollToTop';

module.exports = () => {

	Array.from(document.querySelectorAll('.js-iframe-scroll-to-top')).forEach((self) => {
		if (self.dataset[moduleName + 'Init'] === 'true') return;
		self.dataset[moduleName + 'Init'] = true;

		self.addEventListener('click', (event) => {
			const iframeSelector = self.dataset.target;
			const iframe = document.querySelector(iframeSelector);

			iframeScrollTo(iframe);
			event.preventDefault();
		});
	});



	function iframeScrollTo(iframe, speed) {
		const iframeWindow = iframe.contentWindow;
		const scrollY = iframeWindow.scrollY || iframeWindow.document.documentElement.scrollTop;
		const scrollSpeed = speed || 2000; // time in pixels per second
		const easing = (pos) => {
			return Math.sin(pos * (Math.PI / 2));
		}; // easeOutSine
		const time = Math.max(.1, Math.min(Math.abs(scrollY) / scrollSpeed, .8)); // min time .1, max time .8 seconds
		let currentTime = 0;

		function tick() {
			currentTime += 1 / 60;

			var p = currentTime / time;
			var t = easing(p);

			if (p < 1) {
				iframeWindow.requestAnimationFrame(tick);

				iframeWindow.scrollTo(0, scrollY - scrollY * t);
			} else {
				iframeWindow.scrollTo(0, 0);
			}
		}

		tick();
	}

};